<script setup>
defineProps({
  initiative: {
    type: Number,
    required: true,
  },
  influence: {
    type: Number,
    required: true,
  },
  relational: {
    type: Number,
    required: true,
  },
  structure: {
    type: Number,
    required: true,
  },
  textSize: {
    type: String,
    default: 'base',
  },
})
</script>

<template>
  <div
    class="flex flex-col gap-4 font-semibold"
    :class="[
      { 'text-base': textSize === 'base' },
      { 'text-sm': textSize === 'sm' },
      { 'text-xs': textSize === 'xs' },
    ]"
  >
    <div class="flex flex-col gap-1">
      <div class="flex items-end justify-between">
        <div class="">
          Initiatief
          <span class="font-normal text-gray-600"
            >({{ Math.round(initiative) * 10 }}%)</span
          >
        </div>
        <InfoInitiative />
      </div>
      <FilledBar
        :value="Math.round(initiative) * 10"
        :color="'yellow'"
        class="bg-gray-50"
      />
    </div>

    <div class="flex flex-col gap-1">
      <div class="flex items-end justify-between">
        <div class="">
          Invloed
          <span class="font-normal text-gray-600"
            >({{ Math.round(influence) * 10 }}%)</span
          >
        </div>
        <InfoInfluence />
      </div>
      <FilledBar
        :value="Math.round(influence) * 10"
        :color="'red'"
        class="bg-gray-50"
      />
    </div>

    <div class="flex flex-col gap-1">
      <div class="flex items-end justify-between">
        <div class="">
          Relationeel
          <span class="font-normal text-gray-600"
            >({{ Math.round(relational) * 10 }}%)</span
          >
        </div>
        <InfoRelational />
      </div>
      <FilledBar
        :value="Math.round(relational) * 10"
        :color="'green'"
        class="bg-gray-50"
      />
    </div>

    <div class="flex flex-col gap-1">
      <div class="flex items-end justify-between">
        <div class="">
          Structuur
          <span class="font-normal text-gray-600"
            >({{ Math.round(structure) * 10 }}%)</span
          >
        </div>
        <InfoStructure class="" />
      </div>
      <FilledBar
        :value="Math.round(structure) * 10"
        :color="'blue'"
        class="bg-gray-50"
      />
    </div>
  </div>
</template>
